import { type ModuleWithPermissionsSpecsFragment } from '../../../../api/fragments/ModuleWithPermissionsSpecs';
import FormFields from './FormFields';

const UpdateMobilityForm = (props: {
    updated: string;
    offset: string;
    disabled?: boolean;
    module: ModuleWithPermissionsSpecsFragment;
}) => <FormFields isUpdate {...props} />;

export default UpdateMobilityForm;
